module.exports = __webpack_public_path__ + "media/images/service/n_15-406e87dea2c61d7d97df29825a2e7e58.jpg";